import React from 'react';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import SupportContainer from 'containers/support/SupportContainer';
import { useLocation } from 'react-router';

function Support() {
  const { pathname } = useLocation();

  return (
    <AppTemplate
      title={'Support'}
      leftSide={<AppNav />}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
    >
      <SupportContainer />
    </AppTemplate>
  );
}

export default Support;
